import { FrameBlockModel, type RootBlockModel } from '@blocksuite/hive-model';
import { WidgetComponent, WidgetViewExtension } from '@blocksuite/std';
import { html } from 'lit';
import { repeat } from 'lit/directives/repeat.js';
import { literal, unsafeStatic } from 'lit/static-html.js';

import type { HiveFrameTitle } from './frame-title.js';

export const HIVE_FRAME_TITLE_WIDGET = 'hive-frame-title-widget';

export class HiveFrameTitleWidget extends WidgetComponent<RootBlockModel> {
  private get _frames() {
    return Object.values(this.doc.blocks.value)
      .map(({ model }) => model)
      .filter(model => model instanceof FrameBlockModel);
  }

  getFrameTitle(frame: FrameBlockModel | string) {
    const id = typeof frame === 'string' ? frame : frame.id;
    const frameTitle = this.shadowRoot?.querySelector(
      `hive-frame-title[data-id="${id}"]`
    ) as HiveFrameTitle | null;
    return frameTitle;
  }

  override render() {
    return repeat(
      this._frames,
      ({ id }) => id,
      frame =>
        html`<hive-frame-title
          .model=${frame}
          data-id=${frame.id}
        ></hive-frame-title>`
    );
  }
}

export const frameTitleWidget = WidgetViewExtension(
  'hive:page',
  HIVE_FRAME_TITLE_WIDGET,
  literal`${unsafeStatic(HIVE_FRAME_TITLE_WIDGET)}`
);
